import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
import { BeatLoader } from "react-spinners";
// import EditQuoteForm from './modal/EditQuoteForm';
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import axios from 'axios';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import { adminMainUrl } from "../../../Config";
import { FocusError } from "focus-formik-error";
import Select from "react-select";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { getVehicleDetail } from "../../../Redux/action/Transport/TransportAction";
const VehicleEdit = () => {
    const { b64id } = useParams();
    const token = Cookies.get('token');
    let user_id = Cookies.get('flexichain_user_id');
    const navigate = useNavigate();
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (b64id) {
                let id = atob(b64id);
                if (token && id && user_id) {
                    dispatch(getVehicleDetail(token, user_id, id));
                }
            } else {
                toast.error("Please enter correct url.")
                navigate(-1);
            }
        }

    }, []);
    const dispatch = useDispatch();
    const {
        loadingVehicleDetail,
        VehicleDetailDataError,
        VehicleDetailData
    } = useSelector(state => state?.TransportReducer);

    const [filePreview, setFilePreview] = useState(null);
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

    const validationSchema = Yup.object().shape({
        vehicle_id: Yup.string().required("Please enter vehicle ID"),
        vehicle_type: Yup.string().required("Please select vehicle type"),
        // manufacture_year: Yup.string().required("Please enter manufacture_year"),
        // chassis_number: Yup.string().required("Please enter phone number"),
        // engine_number: Yup.string().required("Please enter primary contact person name"),
        // next_maintenance_date: Yup.string().required("Please enter total experience"),
    });

    const FuelTypeOptions = [
        { value: 'Diesel', label: "Diesel" },
        { value: 'Petrol', label: "Petrol" },
        { value: 'Electric', label: "Electric" },

    ]

  

    const currentVehicleStatusOptions = [
        { value: 'Available', label: "Available" },
        { value: ' In Use', label: " In Use" },
        { value: 'Under Maintenance', label: "Under Maintenance" },


    ]


    const vehicleTypeOptions = [
        { value: 'Truck', label: "Truck" },
        { value: 'Van', label: "Van" },
        { value: 'Trailer', label: "Trailer" },
        { value: 'Other', label: "Other" },
    ]

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };

   


    const formik = useFormik({
        initialValues: {
            vehicle_id: "",
            vehicle_type: "",
            vehicle_model: "",
            license_number: "",
            manufacturer: "",
            chassis_number: "",
            manufacture_year: "",
            
            engine_number: "",
           
            mileage_engine_hrs: "",
            fuel_type: "",
            fuel_efficiency: "",
            last_maintenance_date: "",
            current_vehicle_status: "",
            next_maintenance_date: "",
            notes: "",
           
            



        },
        validationSchema,
        onSubmit: (values, { resetForm }) => {


            setDisableSubmitBtn(true);
            try {
                let config = { headers: { 'auth-token': Cookies.get('token'), 'user_id': user_id, 'Content-Type': 'application/json' } }
                // const formData = new FormData();
                // formData.append("vehicle_id", values.vehicle_id);
                // formData.append("vehicle_type", values.vehicle_type);
                // formData.append("vehicle_model", values.vehicle_model);
                // formData.append("notes", values.notes);
                // formData.append("manufacturer", values.manufacturer);
                // formData.append("license_number", values.license_number);
                // formData.append("fuel_type", values.fuel_type);
                // formData.append("fuel_efficiency", values.fuel_efficiency);
                // formData.append("engine_number", values.engine_number);
                // formData.append("next_maintenance_date", values.next_maintenance_date);
                // formData.append("chassis_number", values.chassis_number);
                // formData.append("manufacture_year", values.manufacture_year);
               
              
                // formData.append("mileage_engine_hrs", values.mileage_engine_hrs);
               
                // formData.append("last_maintenance_date", values.last_maintenance_date);
                // formData.append("current_vehicle_status", values.current_vehicle_status);
               

                axios.post(`${adminMainUrl}/api/transport/vehicle/update?id=${VehicleDetailData?.id}`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            setDisableSubmitBtn(false);
                            toast.success(response?.data?.msg);

                            dispatch(getVehicleDetail(token, user_id, VehicleDetailData?.id));
                            // navigate('/flexichain/transport-vehicle-list')
                        } else {
                            setDisableSubmitBtn(false);
                            toast.error(response?.data?.msg)
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        setDisableSubmitBtn(false);
                        let msg = "";
                        if (err.response) {
                            msg = err.response.data.msg;
                        } else {
                            msg = "Internal Server Error!"
                        };
                        toast.error(msg);
                    })
            } catch (error) {
                setDisableSubmitBtn(false);
                console.log(error);
                toast.error("Internal Server Error!")
            }
        }
    });
   
    useEffect(() => {
        if (VehicleDetailData) {

            formik.setValues({
                vehicle_id: VehicleDetailData?.vehicle_id ?? "",
                vehicle_type: VehicleDetailData?.vehicle_type ?? "",
                vehicle_model: VehicleDetailData?.vehicle_model ?? "",
                license_number: VehicleDetailData?.license_number ?? "",
                manufacturer: VehicleDetailData?.manufacturer ?? "",
                chassis_number: VehicleDetailData?.chassis_number ?? "",
                manufacture_year: VehicleDetailData?.manufacture_year ?? "",
                engine_number: VehicleDetailData?.engine_number ?? "",
                mileage_engine_hrs: VehicleDetailData.mileage_engine_hrs ?? "",
                fuel_type: VehicleDetailData.fuel_type ?? "",
                fuel_efficiency: VehicleDetailData.fuel_efficiency ?? "",
                current_vehicle_status: VehicleDetailData.current_vehicle_status ?? "",
                next_maintenance_date: VehicleDetailData.next_maintenance_date ?? "",
                notes: VehicleDetailData.notes ?? "",
                last_maintenance_date: VehicleDetailData.last_maintenance_date ?? "",
                
              

            })
            setFilePreview(`${adminMainUrl}/${VehicleDetailData?.profile_pic}`)
        }
    }, [VehicleDetailData])
    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file) {
            formik.setFieldValue('profile_pic', file); // Update formik field value
            setFilePreview(URL.createObjectURL(file)); // Set the preview URL
        }
    };


    return (
        <>
            <div className="page-wrapper">
                <form onSubmit={formik.handleSubmit}>
                    <FocusError formik={formik} />
                    <div className="content">
                        <div className="row">
                            <div className="col-md-12">
                                {/* Page Header */}
                                <div className="page-header">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h4 className="page-title">Vehicle Form</h4>
                                        </div>
                                    </div>
                                </div>
                                {/* /Page Header */}
                            </div>
                        </div>
                        <div className="card">

                            <div className="card-body">


                                <div className="main_detail_form mt-2">
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Vehicle information</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Vehicle ID <span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="vehicle_id"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Name"
                                                    value={formik?.values?.vehicle_id}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     if (
                                                //         inputValue.length == 0 &&
                                                //         event.key == " "
                                                //     ) {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik?.touched.vehicle_id &&
                                                    formik?.errors.vehicle_id ? (
                                                    <div className="error">
                                                        {formik?.errors.vehicle_id}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Vehicle Type
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={vehicleTypeOptions}
                                                    name="vehicle_type"
                                                    value={vehicleTypeOptions.find(option => option.value == formik.values.vehicle_type)}
                                                    onChange={option => formik.setFieldValue('vehicle_type', option.value)}
                                                    onBlur={formik.handleBlur}

                                                />

                                                {formik.touched.vehicle_type && formik.errors.vehicle_type ? (
                                                    <div className="error">{formik.errors.vehicle_type}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Vehicle Model
                                                </label>
                                                <input
                                                    type="text"
                                                    name="vehicle_model"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Vehicle Model"
                                                    value={formik?.values?.vehicle_model}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                // pattern="[a-zA-Z\s]*"
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     if (
                                                //         inputValue.length == 0 &&
                                                //         event.key == " "
                                                //     ) {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik?.touched.vehicle_model &&
                                                    formik?.errors.vehicle_model ? (
                                                    <div className="error">
                                                        {formik?.errors.vehicle_model}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Manufacturer
                                                </label>
                                                <input
                                                    type="text"
                                                    name="manufacturer"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Manufacturer"
                                                    value={formik?.values?.manufacturer}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                // pattern="[a-zA-Z\s]*"
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     if (
                                                //         inputValue.length == 0 &&
                                                //         event.key == " "
                                                //     ) {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik?.touched.manufacturer &&
                                                    formik?.errors.manufacturer ? (
                                                    <div className="error">
                                                        {formik?.errors.manufacturer}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="main-nav-det">
                                        <h4 className="form-heading-bg">License Details</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    License Plate Number
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter License Number"
                                                    name="license_number"
                                                    value={formik?.values?.license_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="\d*"
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     if (
                                                //         inputValue.length == 0 &&
                                                //         event.key == " "
                                                //     ) {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik?.touched?.license_number && formik?.errors?.license_number ? (
                                                    <div className="error">{formik?.errors?.license_number}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Chassis Number
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Chassis Number"
                                                    name="chassis_number"
                                                    value={formik?.values?.chassis_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="\d*"
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     if (
                                                //         inputValue.length == 0 &&
                                                //         event.key == " "
                                                //     ) {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik?.touched?.chassis_number && formik?.errors?.chassis_number ? (
                                                    <div className="error">{formik?.errors?.chassis_number}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Year Of Manufacture
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Year Of Manufacture"
                                                    name="manufacture_year"
                                                    value={formik?.values?.manufacture_year}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                // pattern="\d*"
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     if (
                                                //         inputValue.length == 0 &&
                                                //         event.key == " "
                                                //     ) {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik?.touched?.manufacture_year && formik?.errors?.manufacture_year ? (
                                                    <div className="error">{formik?.errors?.manufacture_year}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        </div>

                                        <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Fuel Details</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Engine Number

                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Engine Number
"
                                                    name="engine_number"
                                                    value={formik?.values?.engine_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="\d*"
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     if (
                                                //         inputValue.length == 0 &&
                                                //         event.key == " "
                                                //     ) {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik?.touched?.engine_number && formik?.errors?.engine_number ? (
                                                    <div className="error">{formik?.errors?.engine_number}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Mileage/Engine Hours

                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Mileage/Engine Hours
"
                                                    name="mileage_engine_hrs"
                                                    value={formik?.values?.mileage_engine_hrs}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                // pattern="\d*"
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     if (
                                                //         inputValue.length == 0 &&
                                                //         event.key == " "
                                                //     ) {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik?.touched?.mileage_engine_hrs && formik?.errors?.mileage_engine_hrs ? (
                                                    <div className="error">{formik?.errors?.mileage_engine_hrs}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Fuel Type
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={FuelTypeOptions}
                                                    name="fuel_type"
                                                    value={FuelTypeOptions.find(option => option.value == formik.values.fuel_type)}
                                                    onChange={option => formik.setFieldValue('fuel_type', option.value)}
                                                    onBlur={formik.handleBlur}

                                                />

                                                {formik.touched.fuel_type && formik.errors.fuel_type ? (
                                                    <div className="error">{formik.errors.fuel_type}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Fuel Efficiency (km/l)

                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Fuel Efficiency (km/l)
"
                                                    name="fuel_efficiency"
                                                    value={formik?.values?.fuel_efficiency}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                // pattern="\d*"
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     if (
                                                //         inputValue.length == 0 &&
                                                //         event.key == " "
                                                //     ) {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik?.touched?.fuel_efficiency && formik?.errors?.fuel_efficiency ? (
                                                    <div className="error">{formik?.errors?.fuel_efficiency}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        </div>
                                        <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Vehicle Maintenance Details</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Current Vehicle Status
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={currentVehicleStatusOptions}
                                                    name="current_vehicle_status"
                                                    value={currentVehicleStatusOptions.find(option => option.value == formik.values.current_vehicle_status)}
                                                    onChange={option => formik.setFieldValue('current_vehicle_status', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.current_vehicle_status && formik.errors.current_vehicle_status ? (
                                                    <div className="error">{formik.errors.current_vehicle_status}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Last Maintenance Date
                                                </label>
                                                <div
                                                    className="custom-datepicker"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        name="last_maintenance_date"
                                                        min={new Date().toISOString().split("T")[0]}
                                                        value={formik.values.last_maintenance_date || ""}
                                                        onChange={(e) => {
                                                            formik.setFieldValue(
                                                                "last_maintenance_date",
                                                                e.target.value
                                                            );
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.last_maintenance_date &&
                                                        formik.errors.last_maintenance_date ? (
                                                        <div className="error">
                                                            {formik.errors.last_maintenance_date}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Next Maintenance Date
                                                </label>
                                                <div
                                                    className="custom-datepicker"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        name="next_maintenance_date"
                                                        min={new Date().toISOString().split("T")[0]}
                                                        value={formik.values.next_maintenance_date || ""}
                                                        onChange={(e) => {
                                                            formik.setFieldValue(
                                                                "next_maintenance_date",
                                                                e.target.value
                                                            );
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.next_maintenance_date &&
                                                        formik.errors.next_maintenance_date ? (
                                                        <div className="error">
                                                            {formik.errors.next_maintenance_date}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Notes
                                                </label>
                                                <textarea


                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Notes"
                                                    name="notes"
                                                    value={formik?.values.notes}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                />

                                                {formik.touched.notes && formik.errors.notes ? (
                                                    <div className="error">{formik.errors.notes}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        </div>
                                    </div>





                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <button
                                            className="btn btn-main-form me-md-2"
                                            type="submit"
                                            disabled={disableSubmitBtn}
                                        >
                                            {disableSubmitBtn ? <><i className="fas fa-spinner fa-spin"></i> Saving</> : "Update Vehicle"}
                                        </button>
                                    </div>
                                </div>





                            </div>
                        </div>
                    </div>
                </form >
            </div >
        </>
    )
}

export default VehicleEdit